<template>
  <v-container fill-height fluid grid-list-xl>
    <v-row justify="center">
      <v-col cols="12">
        <material-card
            color="green"
            flat
            full-width
            title="Настройки страницы брендов"
        >
          <v-text-field
              v-model="editedItem.clientChoiceUrl"
              label="Выбор клиентов"
              rows="10"
          />
          <v-text-field
              v-model="editedItem.newArrivalsUrl"
              label="Новые поступления"
              rows="10"
          />
          <p>Изображения</p>
            <file-input :value="editedItem.images" bucket="image" :medias="[]" :show-media="false" :single-mode="false" @change="setImages" />
            <p></p>
          <v-btn @click="Save">Сохранить</v-btn>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { getBrandPageSettings, updateBrandPageSettings } from '@/graphql/brand-page-settings'
import FileInput from '~/components/banners/FileInput'

export default {
  name: 'BrandPageSettings',
  components: {
    FileInput
  },
  layout: 'dashboard',
  apollo: {
    getBrandPageSettings: {
      query: getBrandPageSettings,
      update (data) {
        console.log('update', data)
        this.editedItem = data.brandPage
        return data.brandPage.data
      },
      result ({ data }) {
        this.totalCount = data.brandPage.count
      }
    }
  },
  computed: {
    brandsPageSettings () {
      return this.getBrandPageSettings ?? []
    }
  },
  data () {
    return {
      editedItem: {
        images: []
      }
    }
  },
  methods: {
    setImages (images) {
      this.editedItem.images = images
    },
    Save () {
      console.log(this.editedItem.images.map(item => ({ key: item.file.key, alt: item.alt })))
      this.$apollo
          .mutate({
            mutation: updateBrandPageSettings,
            variables: {
              input: {
                newArrivalsUrl: this.editedItem.newArrivalsUrl,
                clientChoiceUrl: this.editedItem.clientChoiceUrl,
                images: this.editedItem?.images?.length > 0 ? this.editedItem.images.map(item => ({ key: item.file.key, alt: item.alt })) : []
              }
            }
          })
          .then((data) => {
            this.$apollo.queries.getBrandPageSettings.refetch()
          }).catch((error) => {
        console.log(error)
      })
      this.editedItem = {}
    }
  }
}
</script>
